module.exports = "ok";


/*****************
 ** WEBPACK FOOTER
 ** ./parsing/renaming/file.js
 ** module id = 1
 ** module chunks = 0
 **/